<ion-list-header *ngIf="isHeaderVisible && isPatientDisplayed">
	<ion-label>{{title}}</ion-label>
	<ion-button *ngIf="hasSelectPatientButton"
				[disabled]="isSelectPatientButtonDisabled"
				(click)="presentPatientListModal2()"
				class="select-patient-btn">
		{{ patients.length ? "Change Patient" : "Select Patient" }}
	</ion-button>
</ion-list-header>

<ion-accordion-group *ngIf="patients.length && isPatientDisplayed" [multiple]="true" [ngClass]="style">
	<ion-accordion *ngFor="let p of patients; trackBy: trackByPatient; let i = index">
		<ion-item slot="header" class="PatientInfoList">
			<ion-grid>
				<ion-row>
					<ion-col class="ion-no-padding">
						<div class="PatientInfo" [attr.data-testid]="'patient_info__container_' + i">
							<div class="PatientInfo-dob" [style]="isKiosk ? 'background: var(--Primary, #3880ff)' : '' " [attr.data-testid]="'patient_info__dob_' + i">
								<div class="PatientInfo-dob-label">DOB</div>
								<div class="PatientInfo-dob-date">{{p.dateOfBirth.format("DD MMM")}}</div>
								<div class="PatientInfo-dob-year">{{p.dateOfBirth.format("YYYY")}}</div>
							</div>
							<div class="PatientInfo-content" [attr.data-testid]="'patient_info__content_' + i">
								<div>
									<div class="PatientInfo-content-label">Last, First</div>
									<div class="PatientInfo-content-value" [attr.data-testid]="'patient_info__last_name_first_name_' + i">
										<span class="text-uppercase">{{ p.lastName }}</span>, {{ p.firstName }}
									</div>
								</div>
								<div>
									<div class="PatientInfo-content-label">MRN</div>
									<div class="PatientInfo-content-value" [attr.data-testid]="'mrn_' + i">{{ p.mrn }}</div>
								</div>
							</div>
						</div>
					</ion-col>
				</ion-row>
			</ion-grid>
			<ion-icon *ngIf="isKiosk" class="ion-accordion-toggle-icon" name="logo-ionic" slot="end" color="white"></ion-icon>
		</ion-item>
		<ion-list class="patient-info2__content" slot="content" *ngIf="!isKiosk">
			<app-patient-info-content [patient]="p"></app-patient-info-content>
		</ion-list>
	</ion-accordion>
</ion-accordion-group>

<ion-grid *ngIf="!patients.length" class="{{style}}--empty">
	<ion-row>
		<span>{{instructions}}</span>
	</ion-row>
</ion-grid>
